import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import type { KeyCompetitorSite } from "../keyCompetitorsSuggestion";

import { KEY_COMPETITORS_CHIP_AUTOMATION, KEY_COMPETITORS_CHIP_LABEL_KEY } from "./KeyCompetitorsChip.constants";
import { IconStack, KeyCompetitorsChipButton, StackedIcon } from "./KeyCompetitorsChip.styles";

type KeyCompetitorsChipProps = {
    sites: KeyCompetitorSite[];
    onClick: () => void;
};

export const KeyCompetitorsChip = ({ sites, onClick }: KeyCompetitorsChipProps) => {
    const { translate } = useTranslate();

    return (
        <Tooltip
            content={
                <Stack>
                    {sites.map((site) => (
                        <span key={site.Domain}>{site.Domain}</span>
                    ))}
                </Stack>
            }
            placement="bottom"
            role="tooltip"
        >
            <KeyCompetitorsChipButton
                type="flat"
                buttonHtmlType="button"
                width="auto"
                height="auto"
                onClick={onClick}
                dataAutomation={KEY_COMPETITORS_CHIP_AUTOMATION}
            >
                <IconStack aria-hidden>
                    {sites.map((site, index) => (
                        <StackedIcon
                            key={site.Domain}
                            iconSrc={site.Favicon}
                            $hasOffset={index > 0}
                        />
                    ))}
                </IconStack>
                <Text
                    fontVariant="tab"
                    color={colorsPalettes.blue[400]}
                >
                    {translate(KEY_COMPETITORS_CHIP_LABEL_KEY)}
                </Text>
            </KeyCompetitorsChipButton>
        </Tooltip>
    );
};
